<script lang="ts">
  import { FormGroup, RadioButton, RadioButtonGroup } from 'carbon-components-svelte';

  import type { BuildEnv, EmbedValue, SrcMethod } from '../modules/attributes';

  type Props = {
    buildEnv: BuildEnv;
    embedValue: EmbedValue;
    srcMethod: SrcMethod;
  };

  let { buildEnv, embedValue, srcMethod }: Props = $props();
</script>

<FormGroup legendText="Select an Embed Method">
  <RadioButtonGroup bind:selected={embedValue}>
    <RadioButton data-testid="embed--iframe" value={'iframe'} labelText="iFrame" />
    <RadioButton data-testid="embed--alt" value={'alt'} labelText="alt Iframe" />
    <RadioButton data-testid="embed--script" value={'script'} labelText="Script Tag" />
  </RadioButtonGroup>
</FormGroup>
<FormGroup legendText="Select a Build Env">
  <RadioButtonGroup bind:selected={buildEnv}>
    <RadioButton
      data-testid="build--dev"
      disabled={!import.meta.env.DEV && !import.meta.env.VITE_STAGING}
      value={'dev'}
      labelText="Development" />
    <RadioButton data-testid="build--staging" value={'staging'} labelText="Staging" />
    <RadioButton data-testid="build--prod" value={'prod'} labelText="Production" />
  </RadioButtonGroup>
</FormGroup>
{#if import.meta.env.DEV}
  <FormGroup legendText="Select Module or Compiled Loader">
    <RadioButtonGroup disabled={embedValue === 'script'} bind:selected={srcMethod}>
      <RadioButton data-testid="src--module" value={'module'} labelText="Module" />
      <RadioButton data-testid="src--script" value={'script'} labelText="Loader Script" />
    </RadioButtonGroup>
  </FormGroup>
{/if}
